<template>
  <div
    name="xpage-search-results-title"
    class="search-page-search-results-title"
    :class="{ 'sticky-wrapper': sticky }"
  >
    <div v-if="isLoading">Loading...</div>
    <div v-else-if="!isLoading && error">
      {{ searchPageStore.searchPageState.searchResults.errorMessage }}
    </div>
    <div v-else>
      <SearchPageSearchPagination />
      <SearchPageSearchResultsButtons />
      <SearchPageSearchResultsTable
        v-show="
          searchResults &&
          searchResults.length > 0 &&
          !isLoading &&
          searchPageStore.searchPageState.layout !== 'boxes'
        "
        :results="searchResults"
        :showHeaders="true"
				:showRows="false"
        :freezeHeaderRow="searchPageStore.searchPageState.layout === 'table'"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, watch, computed } from "vue";
import { useSearchPageStore } from "@/store/store/searchPageStore";
import SearchPageSearchPagination from "@/components/v2/search-page/SearchPageSearchPagination.vue";
import SearchPageSearchResultsButtons from "@/components/v2/search-page/SearchPageSearchResultsButtons.vue";
import { CertificationSearchResultModel } from "@/types/certifications";
import { DisbursementSearchResultModel } from "@/types/disbursements";
import SearchPageSearchResultsTable from "@/components/v2/search-page/SearchPageSearchResultsTable.vue";

const searchPageStore = useSearchPageStore();

const props = withDefaults(
  defineProps<{
    sticky: boolean;
  }>(),
  {
    sticky: false,
  }
);

const isLoading = computed<boolean>(
  () => searchPageStore.searchPageState.loading
);

const error = computed<boolean>(
  () => searchPageStore.searchPageState.searchResults.error
);

const searchResults = ref<
  CertificationSearchResultModel[] | DisbursementSearchResultModel[]
>([]);

watch(
  () => searchPageStore.searchPageState.searchResults.data,
  (newValue) => {
    searchResults.value = newValue;
  }
);
</script>

<style scoped>
.search-page-search-results-title.sticky-wrapper {
  z-index: 999998;
  position: -webkit-sticky; /* For Safari */
  position: sticky; /* Standard syntax */
  top: var(--xheader-height);
  border-bottom: 1px solid #dddddd;
  background: #ecedef; /* Set a background color for the sticky header */
  width: 100%;
}
</style>
